import { BaseTag }   from "mixs/base/base_mixin";
import { api }       from "apps/api";
import moment from 'moment';
export class Global {
  public static getData(){
    return App.store.getState().data
  }
  public static dataScopeUser(id){          return 'user_' + id; }
  //
  public static getUserData(id){       return this.getData()[this.dataScopeUser(id)]; }
}
export class NotificaionsBase extends BaseTag {
  fromUserName(){
    let userData = Global.getUserData(this.opts.from_user_id);
    if(userData == null){ return ''; }
    return userData.name;
  }
  userName(){
    let userData = Global.getUserData(this.opts.user_id);
    if(userData == null){ return ''; }
    return userData.name;
  }
  moment(){
    return moment(this.opts.created_at);
  }
  ago(){
    return this.moment().fromNow();
  }
}
riot.mixin('notifications.base', NotificaionsBase as riot.TagMixin)
